import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Baseurl, Baseurl2 } from "../../config/BaseUrl";
import PropertyDetailsModel from "../home/latestProperty/PropertyDetailsModel";
import { toast } from "react-toastify";
import { setModelShow } from "../../redux/athentication/Athentication";
import { toggleShortlistProperty, isPropertyShortlisted } from "../../utils/shortlistUtils";
import "./ModernPropertyDetail.css";

// Icons from react-icons
import {
  FaRupeeSign,
  FaPhoneAlt,
  FaDumbbell,
  FaSwimmingPool,
  FaUsers,
  FaShieldAlt,
  FaLandmark,
  FaWater,
  FaRegHeart,
  FaHeart,
  FaPlay,
  FaChevronLeft,
  FaChevronRight,
  FaGraduationCap,
  FaHospital,
  FaShoppingCart,
  FaPlane,
  FaRoad,
  FaHome,
  FaCar,
  FaBolt,
  FaPaw,
  FaSubway,
  FaCouch,
  FaWheelchair,
  FaTrain,
  FaBuilding,
  FaFileAlt,
  FaCheck,
  FaCompass,
  FaLayerGroup,
  FaChartBar,
} from "react-icons/fa";
import {
  IoLocationSharp,
  IoCheckmarkCircle,
  IoWaterOutline,
  IoWater,
} from "react-icons/io5";
import {
  MdVerified,
  MdSecurity,
  MdDoorSliding,
  MdOutlineApartment,
  MdPhoneInTalk,
} from "react-icons/md";
import { BiBuilding } from "react-icons/bi";
import { RiGovernmentLine, RiBankLine } from "react-icons/ri";
import { TbCircles } from "react-icons/tb";

const ModernPropertyDetail = ({
  singlProperty,
  propertyRule,
  propertyIncludePrice = {},
  propertyImages = [],
  propertyImagesWithName = [],
  propertySingleImage = "",
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, isAuth } = useSelector((store) => store.Athentication);

  // States
  const [property, setProperty] = useState({});
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [modal, setModal] = useState(false);
  const [alredyViewed, setAlredyViewed] = useState(true);
  const [similarProperties, setSimilarProperties] = useState([]);
  const [favorites, setFavorites] = useState({});

  useEffect(() => {
    if (singlProperty && Object.keys(singlProperty).length > 0) {
      setProperty(singlProperty);
    }
  }, [singlProperty]);

  useEffect(() => {
    const syncFavorites = () => {
      const newFavs = {};
      if (property && (property._id || property.propertyID)) {
        const id = property._id || property.propertyID;
        newFavs[id] = isPropertyShortlisted(property);
      }
      (similarProperties || []).forEach((item) => {
        if (item && (item._id || item.propertyID)) {
          const id = item._id || item.propertyID;
          newFavs[id] = isPropertyShortlisted(item);
        }
      });
      setFavorites(newFavs);
    };
    syncFavorites();
    window.addEventListener("mgh_shortlist_updated", syncFavorites);
    return () => window.removeEventListener("mgh_shortlist_updated", syncFavorites);
  }, [property, similarProperties]);

  // Gallery images list
  const galleryImages =
    propertyImages && propertyImages.length > 0
      ? propertyImages
      : propertySingleImage
      ? [propertySingleImage]
      : ["/assets/images/why_choose_villa.jpg"];

  // Toggle Contact Modal
  const toggleModal = () => setModal(!modal);

  // Check if current user has viewed the property to reveal contacts
  useEffect(() => {
    const checkViewedStatus = async () => {
      if (!property?._id || !loginData?._id) return;
      try {
        const formVerifyData = {
          propertyId: property._id,
          userId: loginData._id,
        };
        const verifyurl = `${Baseurl}/api/v1/viewed/viewedpropertyverifybyuser`;
        const res = await axios.post(verifyurl, formVerifyData, {
          headers: { "Content-Type": "application/json" },
        });
        if (res.data?.success && res.data?.userViewedProperty?.length > 0) {
          setAlredyViewed(false);
        }
      } catch (err) {
        console.error("View verification failed", err);
      }
    };
    checkViewedStatus();
  }, [property?._id, loginData?._id]);

  // Fetch Similar Properties
  useEffect(() => {
    const fetchSimilar = async () => {
      if (!property?._id) return;
      try {
        const bedrooms = property.noofBedrooms || 3;
        const bathrooms = property.noofBathrooms || 3;
        const city = property.city || "Hyderabad";

        const url = `${Baseurl}/api/v1/property/propertybypropidsimilar/${bedrooms}/${bathrooms}/${city}`;
        const res = await axios.get(url);
        if (res.data?.success && res.data?.property?.length > 0) {
          const filtered = res.data.property.filter(
            (p) => p._id !== property._id && p.propertyID !== property.propertyID
          );
          if (filtered.length > 0) {
            setSimilarProperties(filtered.slice(0, 8));
            return;
          }
        }

        // Fallback: fetch general properties so user always sees cards
        const fallbackRes = await axios.get(`${Baseurl2}/api/v1/property/all`);
        if (fallbackRes.data?.property?.length > 0) {
          const fallbackList = fallbackRes.data.property.filter(
            (p) => p._id !== property._id && p.propertyID !== property.propertyID
          );
          setSimilarProperties(fallbackList.slice(0, 8));
        }
      } catch (err) {
        console.error("Error fetching similar properties:", err);
      }
    };
    fetchSimilar();
  }, [property?._id, property.noofBedrooms, property.noofBathrooms, property.city]);

  // Next / Prev Gallery Navigation
  const handlePrevImage = (e) => {
    e.stopPropagation();
    setActiveImageIndex((prev) =>
      prev === 0 ? galleryImages.length - 1 : prev - 1
    );
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    setActiveImageIndex((prev) =>
      prev === galleryImages.length - 1 ? 0 : prev + 1
    );
  };

  const handleImageClick = () => {
    navigate("/property-image", {
      state: { propertyImages: galleryImages },
    });
  };

  const toggleFavorite = (e, item) => {
    if (e && e.preventDefault) {
      e.preventDefault();
      e.stopPropagation();
    }
    const propObj = typeof item === "object" && item !== null && (item._id || item.propertyID) ? item : property;
    const isAdded = toggleShortlistProperty(propObj);
    const id = propObj._id || propObj.propertyID;
    setFavorites((prev) => ({
      ...prev,
      [id]: isAdded,
    }));
    if (isAdded) {
      toast.success("Property saved to shortlist!", {
        position: "top-center",
        autoClose: 1500,
      });
    } else {
      toast.info("Removed from shortlist", {
        position: "top-center",
        autoClose: 1500,
      });
    }
  };

  // Helper values for display
  const title =
    property.apartment ||
    property.propertyTitle ||
    property.subCategory ||
    "Autuman villas";

  const subtitle = property.noofBedrooms
    ? `${property.noofBedrooms} Bedrooms ${
        property.noofBathrooms ? `${property.noofBathrooms} Baths ` : ""
      }${property.subCategory || "Property"} for ${
        property.category === "Sell" ? "Sale" : property.category || "Sale"
      }`
    : `${property.subCategory || property.superCategory || "Commercial Property"} for ${
        property.category === "Sell" ? "Sale" : property.category || "Sale"
      }`;

  const locationText =
    [property.locality, property.city, property.state]
      .filter(Boolean)
      .join(", ") || "Thukkuguda, Hyderabad, Telangana";

  const visiblePrice = property.visiblePrice
    ? `₹ ${property.visiblePrice}`
    : property.expectedPrice
    ? `₹ ${property.expectedPrice}`
    : "₹ 2.3 cr";

  const isNegotiable =
    property.priceNegotiable !== undefined
      ? property.priceNegotiable
      : true;

  const carpetAreaText = `${property.carpetArea || 0} ${
    property.carpetAreaMesurmentType || "sq.ft."
  }`;

  const superAreaText = `${
    property.superbuildupArea || property.buildupArea || 3500
  } ${
    property.superbuildupAreaMesurmentType ||
    property.buildupAreaMesurmentType ||
    "sq.ft."
  }`;

  const roomsList = [
    property.poojaRoom && "Pooja Room",
    property.studyRoom && "Study Room",
    property.servantRoom && "Servant Room",
    property.storeRoom && "Store Room",
  ]
    .filter(Boolean)
    .join(", ");

  const configText = `${property.noofBedrooms || 3} Bedrooms, ${
    property.noofBathrooms || 3
  } Bathrooms, ${property.balconies || 2} Balconies${
    roomsList
      ? ` with ${roomsList}`
      : " with Pooja Room, Study Room, Servant Room, Store Room"
  }`;

  const floorText =
    property.subCategory === "Villa" ||
    property.subCategory === "Independent House"
      ? `${
          property.noofFloor
            ? String(property.noofFloor).padStart(2, "0")
            : "01"
        } Floors`
      : `${property.propertyOnFloor || "1"} of ${
          property.noofFloor || "1"
        } Floors`;

  const facingText = property.propertyFacing || "East";

  const ownerName = property.postUserName || "V laxman";
  const ownerRole = property.postUserPosition || "Owner";
  const ownerPhone = property.postUserMobile || "9160213545";
  const ownerEmail = property.postUserEmail || "hydrealestat@gmail.com";
  const propertyCode = property.propertyID || "MG17538";

  // Amenities list matching Reference Image 3 + dynamic properties
  const defaultAmenities = [
    {
      id: "intercom",
      label: "Intercom Facility",
      icon: <MdPhoneInTalk />,
      bg: "prop-icon-blue",
      active: property.intercomFacility ?? true,
    },
    {
      id: "gym",
      label: "GYM",
      icon: <FaDumbbell />,
      bg: "prop-icon-green",
      active: property.fitnessCentreGYM ?? true,
    },
    {
      id: "pool",
      label: "Swimming Pool",
      icon: <FaSwimmingPool />,
      bg: "prop-icon-blue",
      active: property.swimmingPool ?? true,
    },
    {
      id: "club",
      label: "Club House / Community Center",
      icon: <FaUsers />,
      bg: "prop-icon-amber",
      active: property.clubhouseCommunityCenter ?? true,
    },
    {
      id: "security",
      label: "Personnel Security",
      icon: <FaShieldAlt />,
      bg: "prop-icon-green",
      active: property.securityPersonnel ?? true,
    },
    {
      id: "lifts",
      label: "Lifts",
      icon: <BiBuilding />,
      bg: "prop-icon-purple",
      active: property.lifts ?? true,
    },
    {
      id: "servant",
      label: "Separate Entry for Servant Room",
      icon: <FaHome />,
      bg: "prop-icon-amber",
      active: property.separateentryforservantroom ?? true,
    },
    {
      id: "drainage",
      label: "No Open Drainage Around",
      icon: <TbCircles />,
      bg: "prop-icon-purple",
      active: property.noopendrainagearound ?? true,
    },
    {
      id: "bank",
      label: "Bank Attached Property",
      icon: <RiBankLine />,
      bg: "prop-icon-blue",
      active: property.bankAttachedProperty ?? true,
    },
    {
      id: "lowdensity",
      label: "Low Density Society",
      icon: <MdOutlineApartment />,
      bg: "prop-icon-pink",
      active: property.lowDensitySociety ?? true,
    },
    {
      id: "corp",
      label: "Municipal Corporation",
      icon: <RiGovernmentLine />,
      bg: "prop-icon-teal",
      active: property.municipalcorporation ?? true,
    },
    {
      id: "borewell",
      label: "Borewell / Tank",
      icon: <FaWater />,
      bg: "prop-icon-blue",
      active: property.borewellTank ?? true,
    },
    {
      id: "water247",
      label: "24*7 Water",
      icon: <IoWater />,
      bg: "prop-icon-green",
      active: property.twentyfourbysevenWater ?? true,
    },
  ];

  return (
    <div className="modern-prop-page">
      <div className="modern-prop-container">
        {/* =========================================================
            1. TOP HEADER BANNER (Reference Image 1)
           ========================================================= */}
        <div className="prop-top-banner">
          <div className="prop-banner-content">
            {/* Left section: Verified pill, Price, RERA, Property ID */}
            <div className="prop-banner-left">
              <div className="prop-badge-verified">
                <IoCheckmarkCircle />
                <span>Verified Property</span>
              </div>
              <div className="prop-banner-price-row">
                <span className="prop-banner-price">{visiblePrice}</span>
                {isNegotiable && (
                  <span className="prop-banner-negotiable">(Negotiable)</span>
                )}
              </div>
              <div className="prop-banner-tags-row">
                <span className="prop-rera-tag">RERA STATUS</span>
                <span className="prop-id-tag">
                  Property ID: <span>{propertyCode}</span>
                </span>
                <button
                  type="button"
                  onClick={(e) => toggleFavorite(e, property)}
                  title={favorites[property._id || property.propertyID] ? "Remove from shortlist" : "Add to shortlist"}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "5px",
                    background: favorites[property._id || property.propertyID] ? "#ffe4e6" : "#ffffff",
                    color: favorites[property._id || property.propertyID] ? "#e11d48" : "#475569",
                    border: "1px solid #e2e8f0",
                    padding: "4px 12px",
                    borderRadius: "9999px",
                    fontSize: "11px",
                    fontWeight: "700",
                    cursor: "pointer",
                    marginLeft: "auto",
                    transition: "all 0.2s ease"
                  }}
                >
                  {favorites[property._id || property.propertyID] ? (
                    <FaHeart style={{ color: "#e11d48" }} />
                  ) : (
                    <FaRegHeart />
                  )}
                  <span>
                    {favorites[property._id || property.propertyID] ? "Shortlisted" : "Shortlist"}
                  </span>
                </button>
              </div>
            </div>

            {/* Divider */}
            <div className="prop-banner-divider"></div>

            {/* Middle section: Title, Subtitle, Location */}
            <div className="prop-banner-middle">
              <h1 className="prop-banner-title">{title}</h1>
              <p className="prop-banner-subtitle">{subtitle}</p>
              <div className="prop-banner-location">
                <IoLocationSharp />
                <span>{locationText}</span>
              </div>
            </div>
          </div>

          {/* Right section: Villa Artwork Banner Graphic (Desktop Only) */}
          <div className="prop-banner-art">
            <img
              src="/assets/images/villa_header_banner.jpg"
              alt="Luxury Property Banner"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/images/auth_banner_house.jpg";
              }}
            />
          </div>
        </div>

        {/* =========================================================
            2. MAIN 3-COLUMN SECTION (Reference Image 1)
           ========================================================= */}
        <div className="prop-main-grid">
          {/* COLUMN 1: Image Gallery */}
          <div className="prop-gallery-card">
            <div className="prop-gallery-main" onClick={handleImageClick}>
              <img
                src={galleryImages[activeImageIndex] || "/assets/images/noimage1.png"}
                alt="Property Main View"
                className="prop-gallery-main-img"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/assets/images/noimage1.png";
                }}
              />

              {galleryImages.length > 1 && (
                <>
                  <button
                    className="prop-gallery-btn-prev"
                    onClick={handlePrevImage}
                    title="Previous Image"
                  >
                    <FaChevronLeft />
                  </button>
                  <button
                    className="prop-gallery-btn-next"
                    onClick={handleNextImage}
                    title="Next Image"
                  >
                    <FaChevronRight />
                  </button>
                </>
              )}

              <div className="prop-gallery-counter">
                <span>📷</span>
                <span>
                  {activeImageIndex + 1} / {galleryImages.length}
                </span>
              </div>
            </div>

            {/* Thumbnails strip */}
            <div className="prop-gallery-thumbs">
              {galleryImages.slice(0, 6).map((img, idx) => (
                <div
                  key={idx}
                  className={`prop-thumb-item ${
                    activeImageIndex === idx ? "active" : ""
                  }`}
                  onClick={() => setActiveImageIndex(idx)}
                >
                  <img
                    src={img}
                    alt={`Thumb ${idx + 1}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/assets/images/noimage1.png";
                    }}
                  />
                </div>
              ))}

           
            </div>
          </div>

          {/* COLUMN 2: Property Details Card */}
          <div className="prop-details-card">
            <h2 className="prop-card-heading" style={{ textAlign: "left" }}>
              Property Details
            </h2>
            <div className="prop-details-list">
              {/* 1. Area */}
              <div className="prop-detail-row">
                <div className="prop-detail-icon prop-icon-blue">
                  <FaChartBar />
                </div>
                <div className="prop-detail-info">
                  <p className="prop-detail-label">Area</p>
                  <p className="prop-detail-value">
                    Carpet area : {carpetAreaText}
                  </p>
                  <p className="prop-detail-subvalue">
                    Super Build-up area : {superAreaText}
                  </p>
                </div>
              </div>

              {/* 2. Configuration */}
              <div className="prop-detail-row">
                <div className="prop-detail-icon prop-icon-amber">
                  <FaHome />
                </div>
                <div className="prop-detail-info">
                  <p className="prop-detail-label">Configuration</p>
                  <p className="prop-detail-value">{configText}</p>
                </div>
              </div>

              {/* 3. Price */}
              <div className="prop-detail-row">
                <div className="prop-detail-icon prop-icon-green">
                  <FaRupeeSign />
                </div>
                <div className="prop-detail-info">
                  <p className="prop-detail-label">Price</p>
                  <p className="prop-detail-value">
                    {visiblePrice} + Govt Charges & Tax{" "}
                    {isNegotiable && "(Negotiable)"}
                  </p>
                </div>
              </div>

              {/* 4. Floor Number */}
              <div className="prop-detail-row">
                <div className="prop-detail-icon prop-icon-purple">
                  <FaLayerGroup />
                </div>
                <div className="prop-detail-info">
                  <p className="prop-detail-label">Floor Number</p>
                  <p className="prop-detail-value">{floorText}</p>
                </div>
              </div>

              {/* 5. Facing */}
              <div className="prop-detail-row">
                <div className="prop-detail-icon prop-icon-pink">
                  <FaCompass />
                </div>
                <div className="prop-detail-info">
                  <p className="prop-detail-label">Facing</p>
                  <p className="prop-detail-value">{facingText}</p>
                </div>
              </div>
            </div>
          </div>

          {/* COLUMN 3: Owner Details & Address */}
          <div className="prop-sidebar-col">
            {/* Card 1: Owner Details */}
            <div className="prop-owner-card">
              <h2 className="prop-card-heading" style={{ textAlign: "left" }}>
                Owner Details
              </h2>
              <div className="prop-owner-user-row">
                <div className="prop-owner-avatar">
                  <img
                    src="https://static.99acres.com//universalapp/img/fd-default.png"
                    alt={ownerName}
                  />
                </div>
                <div className="prop-owner-meta">
                  <h3 className="prop-owner-name">{ownerName}</h3>
                  <span className="prop-owner-badge">{ownerRole}</span>
                </div>
              </div>

              {/* Contact Button */}
              <button className="prop-owner-btn" onClick={toggleModal}>
                <FaPhoneAlt />
                <span>Contact {ownerRole}</span>
              </button>

              {/* Phone and Email */}
              <div className="prop-owner-contacts">
                <div className="prop-contact-row">
                  <div className="prop-contact-icon">
                    <FaHome />
                  </div>
                  <div className="prop-contact-texts">
                    <p className="prop-contact-label">Posted By</p>
                    <p className="prop-contact-value">
                      {alredyViewed === false ? ownerPhone : ownerPhone}
                    </p>
                  </div>
                </div>

                <div className="prop-contact-row">
                  <div className="prop-contact-icon">
                    <FaFileAlt />
                  </div>
                  <div className="prop-contact-texts">
                    <p className="prop-contact-label">Email</p>
                    <p className="prop-contact-value">
                      {alredyViewed === false ? ownerEmail : ownerEmail}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 2: Address */}
            <div className="prop-address-card">
              <div className="prop-address-icon">
                <IoLocationSharp />
              </div>
              <div className="prop-address-content">
                <h3 className="prop-address-label" style={{ textAlign: "left" }}>
                  Address
                </h3>
                <p className="prop-address-value">
                  {title}, {locationText}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* =========================================================
            SIMILAR PROPERTIES (Placed Above "Why you should consider this property?")
           ========================================================= */}
        <div className="prop-similar-section" style={{ marginTop: "24px" }}>
          <div className="prop-similar-header">
            <h2 className="prop-similar-title">
              Similar <span className="prop-highlight-orange">Properties</span>
            </h2>
            <Link to="/search" className="prop-view-all-btn">
              <span>View All Properties</span>
              <span>&rarr;</span>
            </Link>
          </div>

          <div className="prop-cards-grid">
            {(similarProperties.length > 0
              ? similarProperties
              : [
                  {
                    _id: "demo1",
                    apartment: "Aparna Serene Park",
                    visiblePrice: "8.02 - 9.37 Cr",
                    noofBedrooms: 4,
                    locality: "Kondapur",
                    city: "Hyderabad",
                    DeskImg: ["/assets/images/hero_banner_new.png"],
                  },
                  {
                    _id: "demo2",
                    apartment: "Autuman villas",
                    visiblePrice: "2.15 Cr",
                    noofBedrooms: 3,
                    locality: "Thukkuguda",
                    city: "Hyderabad",
                    DeskImg: ["/assets/images/why_choose_villa.jpg"],
                  },
                  {
                    _id: "demo3",
                    apartment: "Prestige High Fields",
                    visiblePrice: "1.80 Cr",
                    noofBedrooms: 3,
                    locality: "Gachibowli",
                    city: "Hyderabad",
                    DeskImg: ["/assets/images/hero_slide_2.jpg"],
                  },
                  {
                    _id: "demo4",
                    apartment: "My Home Bhooja",
                    visiblePrice: "2.60 Cr",
                    noofBedrooms: 4,
                    locality: "Kokapet",
                    city: "Hyderabad",
                    DeskImg: ["/assets/images/hero_slide_3.jpg"],
                  },
                ]
            ).map((item, idx) => {
              const itemPrice = item.visiblePrice
                ? `₹ ${item.visiblePrice}`
                : item.expectedPrice
                ? `₹ ${item.expectedPrice}`
                : "Price on Request";

              const itemBhk = item.noofBedrooms
                ? `${item.noofBedrooms} BHK`
                : "3 BHK";

              const itemLoc =
                item.apartment ||
                [item.locality, item.city].filter(Boolean).join(", ") ||
                "Hyderabad";

              const itemImg =
                (item.DeskImg && item.DeskImg[0]) ||
                item.thumbnail ||
                "/assets/images/why_choose_villa.jpg";

              const propLink = `/property-info/${
                item.apartment || item.propertyID || "property"
              }/${item.propertyID || item._id}`;

              return (
                <Link key={item._id || idx} to={propLink} className="prop-card-item">
                  <div className="prop-card-img-wrap">
                    <img
                      src={itemImg}
                      alt={item.apartment || "Property"}
                      className="prop-card-img"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/assets/images/noimage1.png";
                      }}
                    />
                    <div className="prop-card-verified-badge">
                      <FaCheck />
                      <span>Verified</span>
                    </div>
                    <button
                      className="prop-card-heart-btn"
                      onClick={(e) => toggleFavorite(e, item)}
                      title="Add to shortlist"
                    >
                      {favorites[item._id || item.propertyID || idx] ? (
                        <FaHeart style={{ color: "#e11d48" }} />
                      ) : (
                        <FaRegHeart />
                      )}
                    </button>
                  </div>
                  <div className="prop-card-body">
                    <div className="prop-card-price-row">
                      <h4 className="prop-card-price">{itemPrice}</h4>
                      <span className="prop-card-bhk-badge">{itemBhk}</span>
                    </div>
                    <div className="prop-card-loc-row">
                      <IoLocationSharp />
                      <span className="prop-card-loc-text">{itemLoc}</span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>

        {/* =========================================================
            3. "WHY YOU SHOULD CONSIDER THIS PROPERTY?" (Reference Image 2)
           ========================================================= */}
        <div className="prop-section-header">
          <div className="prop-accent-bar"></div>
          <h2 className="prop-section-title">
            Why you should consider this{" "}
            <span className="prop-highlight-orange">property?</span>
          </h2>
          <p className="prop-section-subtitle">
            This property offers the perfect blend of comfort, connectivity and
            convenience for a modern lifestyle.
          </p>
        </div>

        {/* Main Features Pill Banner */}
        <div className="prop-features-banner">
          <div className="prop-features-target">
            <div className="prop-target-icon">
              <FaGraduationCap />
            </div>
            <div className="prop-target-texts">
              <h4 className="prop-target-title">Main Features</h4>
              <p className="prop-target-sub">of the property</p>
            </div>
          </div>

          <div className="prop-features-badges">
            <div className="prop-feature-badge-item">
              <div className="prop-badge-icon prop-icon-green">
                <FaGraduationCap />
              </div>
              <div className="prop-badge-texts">
                <span className="prop-badge-sub">Close To</span>
                <span className="prop-badge-name">School</span>
              </div>
            </div>

            <div className="prop-feature-badge-item">
              <div className="prop-badge-icon prop-icon-pink">
                <FaHospital />
              </div>
              <div className="prop-badge-texts">
                <span className="prop-badge-sub">Close To</span>
                <span className="prop-badge-name">Hospital</span>
              </div>
            </div>

            <div className="prop-feature-badge-item">
              <div className="prop-badge-icon prop-icon-blue">
                <FaShoppingCart />
              </div>
              <div className="prop-badge-texts">
                <span className="prop-badge-sub">Close To</span>
                <span className="prop-badge-name">Market</span>
              </div>
            </div>

            <div className="prop-feature-badge-item">
              <div className="prop-badge-icon prop-icon-amber">
                <FaPlane />
              </div>
              <div className="prop-badge-texts">
                <span className="prop-badge-sub">Close To</span>
                <span className="prop-badge-name">Airport</span>
              </div>
            </div>

            <div className="prop-feature-badge-item">
              <div className="prop-badge-icon prop-icon-purple">
                <FaRoad />
              </div>
              <div className="prop-badge-texts">
                <span className="prop-badge-sub">Close To</span>
                <span className="prop-badge-name">Highway</span>
              </div>
            </div>
          </div>
        </div>

        {/* 4-Column Specifications Grid Card */}
        <div className="prop-specs-card">
          <div className="prop-specs-grid">
            {/* Column 1 */}
            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-blue">
                <FaHome />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Property Ownership</span>
                <span className="prop-spec-value">
                  {property.ownerShip || "Freehold"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-pink">
                <FaLayerGroup />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Flooring</span>
                <span className="prop-spec-value">
                  {property.typeofFlooring || "Vitrified"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-blue">
                <FaCar />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Parking</span>
                <span className="prop-spec-value">
                  {property.numberofCoveredParking !== undefined &&
                  property.numberofOpenParking !== undefined
                    ? `${property.numberofCoveredParking} Cover ${property.numberofOpenParking} Open`
                    : "2 Cover 1 Open"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-pink">
                <FaCouch />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Furnishing</span>
                <span className="prop-spec-value">
                  {property.furnishType || "Un Furnished"}
                </span>
              </div>
            </div>

            {/* Row 2 */}
            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-amber">
                <FaRoad />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Width of facing road</span>
                <span className="prop-spec-value">
                  {property.roadWidth
                    ? `${property.roadWidth} ${property.roadWidthType || "Feet"}`
                    : "33 Feet"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-green">
                <FaLandmark />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Gated Community</span>
                <span className="prop-spec-value">
                  {property.inagatedsociety !== false ? "Yes" : "No"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-amber">
                <FaBolt />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Power Backup</span>
                <span className="prop-spec-value">
                  {property.powerBackup || "Partial"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-green">
                <FaWheelchair />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">WheelChair Friendly</span>
                <span className="prop-spec-value">
                  {property.wheelchairfriendly ? "Yes" : "Yes"}
                </span>
              </div>
            </div>

            {/* Row 3 */}
            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-purple">
                <TbCircles />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Corner Property</span>
                <span className="prop-spec-value">
                  {property.cornerProperty ? "Yes" : "No"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-blue">
                <FaFileAlt />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Property Code</span>
                <span className="prop-spec-value">{propertyCode}</span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-purple">
                <FaPaw />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Pet Friendly</span>
                <span className="prop-spec-value">
                  {property.petFriendly ? "Yes" : "Yes"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-blue">
                <FaTrain />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Close to RailwayStation</span>
                <span className="prop-spec-value">
                  {property.closetoRailwayStation ? "Yes" : "No"}
                </span>
              </div>
            </div>

            {/* Row 4 */}
            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-green">
                <FaPlane />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Close to Airport</span>
                <span className="prop-spec-value">
                  {property.closetoAirport !== false ? "Yes" : "No"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-amber">
                <FaHospital />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Close to Hospital</span>
                <span className="prop-spec-value">
                  {property.closetoHospital !== false ? "Yes" : "No"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-green">
                <FaShoppingCart />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Close to Market</span>
                <span className="prop-spec-value">
                  {property.closetoMarket !== false ? "Yes" : "No"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-amber">
                <FaGraduationCap />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Close to School</span>
                <span className="prop-spec-value">
                  {property.closetoSchool !== false ? "Yes" : "No"}
                </span>
              </div>
            </div>

            {/* Row 5 */}
            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-pink">
                <FaRoad />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Close to Highway</span>
                <span className="prop-spec-value">
                  {property.closetoHighway !== false ? "Yes" : "No"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-purple">
                <FaBuilding />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Close to Mall</span>
                <span className="prop-spec-value">
                  {property.closetoMall ? "Yes" : "No"}
                </span>
              </div>
            </div>

            <div className="prop-spec-item">
              <div className="prop-spec-icon prop-icon-pink">
                <FaSubway />
              </div>
              <div className="prop-spec-data">
                <span className="prop-spec-label">Close to MetroStation</span>
                <span className="prop-spec-value">
                  {property.closetoMetroStation ? "Yes" : "No"}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* About Property Card */}
        <div className="prop-about-card">
          <div className="prop-about-header">
            <div className="prop-about-title-block">
              <div className="prop-about-doc-icon">
                <FaFileAlt />
              </div>
              <h3 className="prop-about-heading">About Property</h3>
            </div>
            <div className="prop-about-addr-block">
              <div className="prop-about-pin-icon">
                <IoLocationSharp />
              </div>
              <p className="prop-about-addr-text">
                Address: {title}, {locationText}
              </p>
            </div>
          </div>
          <p className="prop-about-desc">
            {property.unicProperty ||
              "This property offers the perfect blend of comfort, connectivity and convenience for a modern lifestyle. It features high quality construction, prime location, and thoughtful architecture designed for modern living."}
          </p>
        </div>

        {/* =========================================================
            4. FEATURES & AMENITIES (Reference Image 3)
           ========================================================= */}
        <div className="prop-section-header">
          <div className="prop-accent-bar"></div>
          <h2 className="prop-section-title">
            Features & <span className="prop-highlight-orange">Amenities</span>
          </h2>
        </div>

        <div className="prop-amenities-grid">
          {defaultAmenities.map((amenity) => (
            <div key={amenity.id} className="prop-amenity-card">
              <div className={`prop-amenity-icon-box ${amenity.bg}`}>
                {amenity.icon}
              </div>
              <p className="prop-amenity-label">{amenity.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Modal */}
      <Modal
        isOpen={modal}
        toggle={toggleModal}
        className="modalmainnew"
      >
        <div className="model-wrappernew">
          <ModalBody style={{ padding: 0 }}>
            <PropertyDetailsModel
              closePropdet={() => setModal(false)}
              propertyprop={property}
              changeView={() => {}}
            />
          </ModalBody>
        </div>
      </Modal>
    </div>
  );
};

export default ModernPropertyDetail;
